import styled from "styled-components";

const SelectInput = styled.select<{
  error: boolean;
}>`
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ error, theme }) =>
    error ? theme.colors.error : theme.colors.border};
  box-sizing: border-box;
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  box-shadow: none;
  font-weight: 500;

  :focus {
    outline: none;
    border-color: ${({ error, theme }) =>
      error ? theme.colors.error : theme.colors.primary};
  }

  ::placeholder {
    font-style: italic;
    color: ${({ theme }) => theme.colors.muted};
  }
`;

export default SelectInput;
